"use client";

import { motion } from "framer-motion";
import { Sparkles, ShieldCheck, CheckCircle2 } from "lucide-react";
import AutopilotPhone from "./AutopilotPhone";

function Defuse() {
  const items = [
    "Pauses on tough reviews. You always see the draft first.",
    "You set the tone — friendly, formal, witty. It learns your voice.",
    "One word turns it off forever. No begging.",
  ];
  return (
    <ul className="mt-6 space-y-3">
      {items.map((t) => (
        <li
          key={t}
          className="flex items-start gap-3 rounded-xl border border-ink-100 bg-white p-3.5"
        >
          <CheckCircle2
            className="mt-0.5 h-4 w-4 shrink-0 text-accent-600"
            aria-hidden="true"
          />
          <span className="text-sm text-ink-700">{t}</span>
        </li>
      ))}
    </ul>
  );
}

function ControlCard() {
  return (
    <div className="mt-6 rounded-2xl border border-ink-100 bg-ink-50 p-5">
      <div className="flex items-center gap-2 text-ink-700">
        <ShieldCheck className="h-4 w-4" aria-hidden="true" />
        <span className="text-xs font-bold uppercase tracking-wider">
          You&apos;re always in charge
        </span>
      </div>
      <p className="mt-2 text-sm text-ink-600">
        Every autopilot notice comes with{" "}
        <strong>See draft</strong> and <strong>Pause</strong> buttons. One tap
        and the reply waits for you, or autopilot stops for the day. Turn it
        off entirely from the dashboard whenever you like.
      </p>
    </div>
  );
}

export default function Autopilot() {
  return (
    <section className="bg-ink-50 py-20 sm:py-28">
      <div className="mx-auto grid max-w-6xl gap-14 px-6 lg:grid-cols-[1.05fr_0.95fr] lg:items-center">
        <div>
          <p className="ribbon mb-3 text-ink-500">Autopilot, when you&apos;re ready</p>
          <h2 className="font-display text-4xl font-bold tracking-tight text-ink-950 sm:text-5xl text-balance">
            Or skip the tap and let it run{" "}
            <em className="font-display italic font-normal text-brand-600">
              itself.
            </em>
          </h2>
          <p className="mt-4 text-lg text-ink-600 text-pretty">
            <Sparkles className="mr-1 inline h-4 w-4 text-brand-600" />
            Auto-post 5-star replies while you sleep. You get a heads-up first,
            and a digest at the end of the day.
          </p>

          <Defuse />
          <ControlCard />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="flex justify-center lg:justify-end"
        >
          <AutopilotPhone />
        </motion.div>
      </div>
    </section>
  );
}
